import { Service } from '@/services/api';

export interface UpdateUserRoleRequest {
  userId: number;
  roleName: string;
}

class AuthService extends Service {
  async updateUserRole(request: UpdateUserRoleRequest): Promise<void> {
    return this.post<void>(`/v2/auth/user-security-group`, request).then(this.handleResponse);
  }
}

export default new AuthService();
